"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTransactionsSortToJSON = exports.GetTransactionsSortFromJSONTyped = exports.GetTransactionsSortFromJSON = exports.GetTransactionsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetTransactionsSort;
(function (GetTransactionsSort) {
    GetTransactionsSort["CreatedAt"] = "createdAt";
    GetTransactionsSort["UpdatedAt"] = "updatedAt";
})(GetTransactionsSort = exports.GetTransactionsSort || (exports.GetTransactionsSort = {}));
function GetTransactionsSortFromJSON(json) {
    return GetTransactionsSortFromJSONTyped(json, false);
}
exports.GetTransactionsSortFromJSON = GetTransactionsSortFromJSON;
function GetTransactionsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetTransactionsSortFromJSONTyped = GetTransactionsSortFromJSONTyped;
function GetTransactionsSortToJSON(value) {
    return value;
}
exports.GetTransactionsSortToJSON = GetTransactionsSortToJSON;
